var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityIconsCritical24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6006 15.4315L14.6236 3.15968C14.0503 2.20842 13.0592 1.63281 11.9947 1.63281C10.9302 1.63281 9.93915 2.20842 9.36582 3.15968L2.38879 15.4315C1.88716 16.3184 1.86982 17.4218 2.34331 18.3259C2.89089 19.3438 3.91266 19.9704 5.01768 19.966H18.9717C20.0692 19.9784 21.0892 19.3676 21.6461 18.3644C22.1338 17.4505 22.1164 16.328 21.6006 15.4315Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6006 15.4315L14.6236 3.15968C14.0503 2.20842 13.0592 1.63281 11.9947 1.63281C10.9302 1.63281 9.93915 2.20842 9.36582 3.15968L2.38879 15.4315C1.88716 16.3184 1.86982 17.4218 2.34331 18.3259C2.89089 19.3438 3.91266 19.9704 5.01768 19.966H18.9717C20.0692 19.9784 21.0892 19.3676 21.6461 18.3644C22.1338 17.4505 22.1164 16.328 21.6006 15.4315ZM11.9948 16.1064C11.4924 16.1064 11.0852 15.6744 11.0852 15.1416C11.0852 14.6088 11.4924 14.1768 11.9948 14.1768C12.4972 14.1768 12.9045 14.6088 12.9045 15.1416C12.9045 15.6744 12.4972 16.1064 11.9948 16.1064ZM11.9948 13.2121C12.4972 13.2121 12.9045 12.7801 12.9045 12.2473V8.38823C12.9045 7.8554 12.4972 7.42346 11.9948 7.42346C11.4924 7.42346 11.0852 7.8554 11.0852 8.38823V12.2473C11.0852 12.7801 11.4924 13.2121 11.9948 13.2121Z",
    fill: "#70010E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIconsCritical24);
export default __webpack_public_path__ + "static/media/severity-icons-critical-24.555312248b4e66e1c6e535f494bd06dc.svg";
export { ForwardRef as ReactComponent };